"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pass = void 0;
function pass(predicate) {
    return function (t) { return (predicate(t) ? t : undefined); };
}
exports.pass = pass;
